module.exports = __webpack_public_path__ + "img/nav_icon_dashboard_dk.70d39abf.svg";